module.exports = __webpack_public_path__ + "static/media/amk.f2f5e3e7.png";